import { IClaimDtoClaimStatusEnum } from '@/types';

export enum LMNPopupMode {
  EDIT = 'EDIT',
  VIEW = 'VIEW',
  UPLOAD = 'UPLOAD',
  CONVERT = 'COVERT',
  PARTIAL_EDIT = 'PARTIAL_EDIT',
}

export enum LMNPopupStep {
  DOCUMENT_PREVIEW = 'DOCUMENT_PREVIEW',
  ASSOCIATE_WITH_CLAIMS = 'ASSOCIATE_WITH_CLAIMS',
  CLAIMS_REVIEW_POPUP = 'CLAIMS_REVIEW_POPUP',
}
export interface LettersOfMedicalNecessityPayload {
  id?: number;
  name?: string;
  file_url?: string;
  description?: string;
  valid_from?: string;
  valid_to?: string;
  document_id?: number;
  employee_id?: number;
  organization_id?: number;
  organization_path?: string;
  claim_ids?: number[];
  claims?: LMNClaimDto[];
  provider_id?: number;
  created_at?: string;
}
export interface LettersOfMedicalNecessity {
  id?: string;
  name?: string;
  description?: string;
  validFrom?: string;
  validTo?: string;
  fileUrl?: string;
  thumbnailUrl?: string;
  documentId?: string;
  employeeId?: string;
  organizationId?: string;
  organizationPath?: string;
  claimIds?: string[];
  claims?: LMNClaim[];
  providerId?: string;
  createdAt?: string;
}
export interface LMNClaim {
  claimId?: string;

  providerName?: string;
  serviceId?: string;
  statusType?: IClaimDtoClaimStatusEnum;
  approvalStatus?: string;
  requestedAmount?: number;
  serviceOn?: string;
}
// TODO: get from common-fe
export interface LMNClaimDto {
  claim_id?: number;
  provider_name?: string;
  service_id?: number;
  requested_amount?: number;
  service_on?: string;
  approval_status?: string;
  status_type?: IClaimDtoClaimStatusEnum;
}

export const LMN_UPLOAD_STORE_KEY = 'LMN_UPLOAD_STORE_KEY';
